import { COLORS } from '../../constants/theme';
import {
  hostilityTier,
  HOSTILITY_HOSTILE_THRESHOLD,
  HOSTILITY_TIER_COLORS,
  hostilityBarWidthPercent,
} from './relationsPresentation';

interface Props {
  value: number;
  label: string;
}

/**
 * SF-158 (Phase 3 Decision 2): stateless hostility meter. 0-15 denominator — 15 is the actionable
 * War-declaration range (docs/GAME_MECHANICS.md), not the real 0-200 accumulation cap; values
 * above 15 still render a fully-clamped bar with the raw number always shown as text, so nothing
 * is hidden.
 */
export function HostilityBar({ value, label }: Props) {
  const tier = hostilityTier(value);
  const color = HOSTILITY_TIER_COLORS[tier];
  const width = hostilityBarWidthPercent(value);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: 11, color: COLORS.text.tertiary }}>
        <span>{label}</span>
        <span style={{ color, fontWeight: 600 }}>{value}</span>
      </div>
      <div
        role="progressbar"
        aria-label={label}
        aria-valuenow={Math.min(value, HOSTILITY_HOSTILE_THRESHOLD)}
        aria-valuemin={0}
        aria-valuemax={HOSTILITY_HOSTILE_THRESHOLD}
        aria-valuetext={String(value)}
        style={{
          height: 6,
          background: COLORS.cardAlt,
          border: `1px solid ${COLORS.borderInset}`,
          borderRadius: 3,
          overflow: 'hidden',
        }}
      >
        <div style={{ height: '100%', width: `${width}%`, background: color, transition: 'width 0.3s' }} />
      </div>
    </div>
  );
}
